import { useUserPreferences } from '@/hooks/rxdb-models';

/**
 * Reads whether live LLM streaming is enabled from user preferences.
 * Defaults to off when the preference is missing.
 */
export const useStreamingEnabled = (): boolean => {
  const { preferences } = useUserPreferences();
  return preferences?.stream === true;
};
